module.exports = __webpack_public_path__ + "assets/img/2019_5.baa783a9.png";